module.exports = __webpack_public_path__ + "static/media/damacai-inversed.336ac970.png";